import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/events/listing.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getEvents = (_0) => __async(null, [_0], function* ({
  lang,
  publicOnly,
  organizationSlug,
  seasonSlug = "",
  teamSlug = "",
  status = "upcoming",
  page,
  perPage,
  eventType
}) {
  var _a, _b;
  try {
    const params = new URLSearchParams();
    const locale = getLocaleOnly(lang);
    params.append("lang", locale);
    if (seasonSlug) params.append("season_slug", seasonSlug);
    if (teamSlug) params.append("team_slug", teamSlug);
    if (status) params.append("status", status);
    if (eventType) params.append("event_type", eventType);
    if (page) params.append("page", String(page));
    if (perPage) params.append("per_page", String(perPage));
    params.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    const data = yield fetchClient({
      url: `/filter/events/${organizationSlug}?${params.toString()}`,
      includeAuth: false
    });
    let events = data.data.data;
    let seasons = data.seasons;
    if (publicOnly) {
      events = data.data.data.filter((event) => event.visibility === "public");
      seasons = data.seasons.filter((season) => season.visibility === "public");
    } else {
      events = data.data.data.filter((event) => ["public", "private"].includes(event.visibility));
      seasons = data.seasons.filter((season) => ["public", "private"].includes(season.visibility));
    }
    return {
      events,
      seasons,
      total: data.data.total,
      per_page: data.data.per_page,
      current_page: data.data.current_page
    };
  } catch (error) {
    throw new Exception({ error, name: "getEventsException" });
  }
});
var eventsListByOrganizationSlug = (_0) => __async(null, [_0], function* ({ lang, page, perPage, slug }) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const search = new URLSearchParams();
    search.append("lang", locale);
    search.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    search.append("page", (page == null ? void 0 : page.toString()) || "0");
    search.append("per_page", (perPage == null ? void 0 : perPage.toString()) || "10");
    const base = `/organizations/${slug}/events`;
    const res = yield fetchClient({
      url: `${base}?${decodeURIComponent(search.toString())}`,
      includeAuth: false
    });
    return res.data;
  } catch (error) {
    throw new Exception({ error, name: "eventsListByOrganizationSlugException" });
  }
});
var getOrganizationsEvents = (_0) => __async(null, [_0], function* ({
  lang,
  publicOnly,
  seasonSlug = "",
  teamSlug = "",
  status = "upcoming",
  page,
  perPage,
  eventType,
  organizationSlugs
}) {
  var _a, _b;
  try {
    const params = new URLSearchParams();
    const locale = getLocaleOnly(lang);
    params.append("lang", locale);
    organizationSlugs.forEach((slug, index) => {
      params.append(`organization_slugs[${index}]`, slug);
    });
    if (seasonSlug) params.append("season_slug", seasonSlug);
    if (teamSlug) params.append("team_slug", teamSlug);
    if (status) params.append("status", status);
    if (eventType) params.append("event_type", eventType);
    if (page) params.append("page", String(page));
    if (perPage) params.append("per_page", String(perPage));
    params.append("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    const data = yield fetchClient({
      url: `/filter/events?${params.toString()}`,
      includeAuth: false
    });
    let events = data.data.data;
    let seasons = data.seasons;
    if (publicOnly) {
      events = data.data.data.filter((event) => event.visibility === "public");
      seasons = data.seasons.filter((season) => season.visibility === "public");
    } else {
      events = data.data.data.filter((event) => ["public", "private"].includes(event.visibility));
      seasons = data.seasons.filter((season) => ["public", "private"].includes(season.visibility));
    }
    return {
      events,
      seasons,
      total: data.data.total,
      per_page: data.data.per_page,
      current_page: data.data.current_page
    };
  } catch (error) {
    throw new Exception({ error, name: "getOrganizationsEventsException" });
  }
});

export {
  getEvents,
  eventsListByOrganizationSlug,
  getOrganizationsEvents
};
//# sourceMappingURL=chunk-OVZ7EZQN.mjs.map